
export const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export function buildImageUrl(visualHash: string): string {
    return `https://bria-image-repository.s3.amazonaws.com/${isDevelopment ? "integration/" : ""}images/${visualHash}.jpeg`
}

